import type {TargetLiterals} from '@github-ui/custom-properties-types'
import {Banner} from '@primer/react'

type Props = {
  propertyName: string
  count?: number
  targetLiterals: TargetLiterals
  errorMessage?: string
}

export function DefinitionUsageBanner({propertyName, count, targetLiterals, errorMessage}: Props) {
  const hasUsages = count && count > 0
  const variant = hasUsages || errorMessage ? 'warning' : 'info'
  const targetLiteral = count === 1 ? targetLiterals.single : targetLiterals.multiple

  const renderDescription = () => {
    if (errorMessage) {
      return <span>{errorMessage}</span>
    } else if (hasUsages) {
      return (
        <span>
          The <strong>{propertyName}</strong> property is referenced by{' '}
          <strong>
            {count} {targetLiteral}.
          </strong>
        </span>
      )
    }
    return (
      <span>
        No usages of the <strong>{propertyName}</strong> property found.
      </span>
    )
  }

  return (
    <Banner
      title="Definition usage"
      hideTitle
      variant={variant}
      data-testid="usage-banner"
      description={renderDescription()}
    />
  )
}

try{ DefinitionUsageBanner.displayName ||= 'DefinitionUsageBanner' } catch {}